import { render, staticRenderFns } from "./myNeeder.vue?vue&type=template&id=7f9f865a&scoped=true&"
import script from "./myNeeder.vue?vue&type=script&lang=js&"
export * from "./myNeeder.vue?vue&type=script&lang=js&"
import style0 from "./myNeeder.vue?vue&type=style&index=0&id=7f9f865a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9f865a",
  null
  
)

export default component.exports